
const { PUBLIC_URL, REACT_APP_API_URL } = process.env;
const baseUrl = window.location.href ?? '/';


const DefaultConstants = {
    developer: {
        name: "Easy Pro",
        website: "http://easypro.dev.br/"
    },

    publicUrl: `${PUBLIC_URL ?? './'}${window.location.pathname}`,
    apiUrl: `${REACT_APP_API_URL ?? baseUrl}/backend/?route=`,
    
    systemName: 'Easy Tools',

    gridRowSpacing: 2,
    gridColumnSpacing: 2,

    dataGridRegistrationStatusType: 'RegistrationStatusEnum'
};

const systemNameFormatted = DefaultConstants.systemName.toLowerCase().replace(/ /g, '').toLowerCase();
const StorageConstants = {
    languageStorageName: `${systemNameFormatted}_currentlanguage`,
    authTokenStorageName: `${systemNameFormatted}_authtoken`,
    enterpriseIdStorageName: `${systemNameFormatted}_enterpriseid`,
    sessionIdStorageName: `${systemNameFormatted}_sessionid`
}


const KeyConstants = {
    privateKey: 'jz4ii5k7e7ujmstz'
}


export {
    StorageConstants,
    KeyConstants
}

export default DefaultConstants;

